module.exports = __webpack_public_path__ + "img/agua.497e1cf1.png";